import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link as RouterLink } from 'react-router-dom';
import { useMutation } from 'react-query';

export default function ListAddresses() {
    const [addresss, setaddresss] = useState(null);
    const { isLoading: isLoadingaddresss, refetch: getaddresss } = useQuery(
        "show-address",
        async () => {
          return await apiClient.get("/api/show-address");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setaddresss(res.data.wallets);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      const { mutate: deleteAddress } = useMutation(
        async (addressId) => {
          return await apiClient.delete(`/api/delete-address/${addressId}`);
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            getaddresss(); // Refresh the list
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            localStorage.setItem('notification', JSON.stringify({message : `Error: ${myerror.message || 'Failed to delete wallet address'}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

      const handleDelete = (addressId, coinName, walletAddress) => {
        if (window.confirm(`Are you sure you want to delete the wallet address for "${coinName}"?\n\nAddress: ${walletAddress}\n\nThis action cannot be undone.`)) {
          deleteAddress(addressId);
        }
      };

      useEffect(() => {
        getaddresss() 
        if (isLoadingaddresss) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingaddresss? 'Loading addresses...' : 'List of Wallet Addresses'}
      </Typography>
    <TableContainer component={Paper}>
        
      {addresss !== null && (
        <>
          {/* Results Counter */}
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Total: {addresss.length} wallet addresses
            </Typography>
          </Box>
          
          <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>Coin Name</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>Wallet Address</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>Wallet Type</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>Display Area</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {addresss.map((address) => (
          <TableRow
            key={address.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {address.coin_name}
            </TableCell>
            <TableCell align="right" sx={{ wordBreak: 'break-all', maxWidth: '200px' }}>
              {address.address}
            </TableCell>
            <TableCell align="right">{address.wallet_type}</TableCell>
            <TableCell align="right">{address.display_area}</TableCell>
            <TableCell align="right">
              <Button 
                component={RouterLink} 
                to={`/edit-address/${address.id}`} 
                startIcon={<EditIcon />}
                size="small"
                sx={{ mr: 1 }}
              >
                Edit
              </Button>
              <Button 
                onClick={() => handleDelete(address.id, address.coin_name, address.address)}
                startIcon={<DeleteIcon />}
                color="error"
                size="small"
              >
                Delete
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
        </>
      )}
      
    </TableContainer>
    </Container>
    </div>
  );
}